<template>
  <b-form-group
    :label="label"
    :label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      :name="name"
      :rules="validate"
      :ref="name"
    >
      <input
        :id="id"
        :disabled="disabled"
        :type="type"
        :class="['form-control' , { 'is-invalid': errors.length > 0 }]"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      >
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
export default {
  props: {
    /* errors: {
      type: Object
    }, */
    ref: {
      default: '',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    name: {
      default: '',
      type: String
    },
    type: {
      default: 'text'
    },
    id: {
      default: '',
      type: String
    },
    validate: {
      default: '',
      required: false
    },
    value: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    disabled: {
      default: false
    }
  },
  methods: {
    test (t, y) {
      console.log(t, y)
    }
  }
/*  watch: {
    'errors' (val) {
      this.$refs.user.setErrors(val.user)
    }
  } */
}
</script>
<style>
/*form .form-control {
  box-shadow: 0 0px 4px 1px #2b58422e inset;
}*/
</style>
